module.exports = __webpack_public_path__ + "media/proksee-viewer/images/icon-chevron-5d800efacac83ee0b5d1d6aef89b30ad.png";